import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import { CreateValidateTextField } from "..";
import { Dialog, DialogTitle, Snackbar, Alert } from "@mui/material";
import { Edit as EditIcon, Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from "@mui/icons-material";

function FacultyEdit(props) {
  const { updateTable, setUpdateTable, faculty } = props;

  const [openEditDialog, setOpenEditDialog] = useState(false);
  
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [pid, setPid] = useState("");
  const [websiteURL, setWebsiteURL] = useState("");
  
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");


  useEffect(() => {
    // Set the fields back to the faculty's data
    setFirstName(faculty.firstName);
    setLastName(faculty.lastName);
    setPid(faculty.pid);
    setWebsiteURL(faculty.websiteURL);
  }, [faculty, openEditDialog]);

  const handleEditFaculty = (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("facultyId", faculty.facultyId);
    body.append("firstName", firstName);
    body.append("lastName", lastName);
    body.append("oldPid", faculty.pid);
    body.append("pid", pid);
    body.append("email", pid + "@vt.edu");
    body.append("websiteURL", websiteURL);
    axios.post("/faculty/editFaculty", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenEditDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const resetHooks = () => {
    setFirstName("");
    setLastName("");
    setPid("");
    setWebsiteURL("");
  };

  function showEditDialog(open) {
    return (
      <Dialog open={open} maxWidth={false}>
        <DialogTitle className="FacultyEdit-title mx-auto text-2xl font-bold font-brand-primary">
          {"Edit A Faculty's Login"}
        </DialogTitle>
        <div className="FacultyCreate-modalContainer flex flex-col w-fit mb-4 mx-8">
          <div className="FacultyCreate-firstNameContainer flex flex-col w-96 mx-auto mb-2">
            <div className="FacultyCreate-firstName text-lg font-brand-primary">
              Faculty First Name: *
            </div>
            <CreateValidateTextField
              placeholder="First Name"
              pattern="(?=.*\w).+"
              value={firstName}
              setter={setFirstName}
              errorMessage={"Invalid First Name."}
              required={true}
            />
          </div>
          <div className="FacultyCreate-lastNameContainer flex flex-col w-96 mx-auto mb-2">
            <div className="FacultyCreate-lastName text-lg font-brand-primary">
              Faculty Last Name: *
            </div>
            <CreateValidateTextField
              placeholder="Last Name"
              pattern="(?=.*\w).+"
              value={lastName}
              setter={setLastName}
              errorMessage={"Invalid Last Name."}
              required={true}
            />
          </div>
          <div className="FacultyCreate-pidContainer flex flex-col w-96 mx-auto mb-2">
            <div className="FacultyCreate-pid text-lg font-brand-primary">
              Pid: *
            </div>
            <CreateValidateTextField
              placeholder="pid"
              pattern="(?=.*\w).+"
              value={pid}
              setter={setPid}
              errorMessage={"Invalid pid."}
              required={true}
            />
          </div>
          <div className="FacultyCreate-websiteURLContainer flex flex-col w-96 mx-auto mb-2">
            <div className="FacultyCreate-websiteURL text-lg font-brand-primary">
              Website URL: *
            </div>
            <CreateValidateTextField
              placeholder="https://website.cs.vt.edu/people/faculty/YOU.html"
              pattern="(https:\/\/)?(www\.)?((?=[a-zA-Z0-9])[a-zA-Z0-9_-]+(?<=[a-zA-Z0-9])\.)+[a-zA-Z0-9]{2,}\/?(\/?[a-zA-Z0-9-#?_]*)*(\.html)?"
              value={websiteURL}
              setter={setWebsiteURL}
              errorMessage={"Invalid website URL."}
              required={true}
            />
          </div>
          <div className="FacultyCreate-emailContainer flex flex-col w-96 mx-auto mb-2">
            <div className="FacultyCreate-email text-lg font-brand-primary">
              Your email will be automatically set to yourpid@vt.edu.
            </div>
          </div>
          <div className="FacultyEdit-buttonContainer flex justify-between px-8 mt-4">
            <button
              type="button"
              className="FacultyEdit-updateButton primary-button bg-brand-quaternary mb-2 h-11 pt-3 mr-4"
              onClick={handleEditFaculty}
            >
              Update Faculty
            </button>

            <button
              type="button"
              className="FacultyEdit-cancelButton primary-button bg-brand-primary mb-2 h-11 pt-3"
              onClick={() => setOpenEditDialog(false)}
            >
              Cancel
            </button>
          </div>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="FacultyEdit-container">
      {showEditDialog(openEditDialog)}
      <button className="flex mr-4" onClick={() => setOpenEditDialog(true)}>
        <EditIcon fontSize="large" className="fill-brand-quaternary" />
      </button>
    </div>
  );
}

FacultyEdit.propTypes = {
  updateTable: PropTypes.bool,
  setUpdateTable: PropTypes.func,
  faculty: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    facultyId: PropTypes.number,
    pid: PropTypes.string,
    websiteURL: PropTypes.string,
  }),
};

FacultyEdit.defaultProps = {
  updateTable: false,
  setUpdateTable: () => { },
  faculty: {},
};

export default FacultyEdit;
